import { setNotifyStatus } from './notifyActions';

export const errorHandler = (error) => dispatch => {
  dispatch(setNotifyStatus({
    type: 'error',
    content: getError(error),
  }));
};
const getError = (message) => (message ? message : `An error has occurred`);